var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"truck-marker",style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        minWidth: _vm.size + 'px',
        border: _vm.border,
        borderColor: _vm.borderColor,
        boxShadow: _vm.boxShadow,
    })},[(_vm.src)?_c('img',{staticClass:"truck-marker__img",attrs:{"src":_vm.src,"alt":"Avatar"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }